import { FileUrlFields } from 'drapcode-constant';
export default async function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  let { collection, session, sessionTenant, sessionUserSettings, sessionSubTenant } =
    opt.bindCollectionOptions;

  if (!collection) {
    collection = opt.snippetCollectionTraitOptions.collection;
  }

  const traitOptions = collection
    ? collection.options
        .filter((field) => {
          return (
            FileUrlFields.includes(field.type) ||
            (field.type &&
              field.metaData &&
              FileUrlFields.includes(JSON.parse(field.metaData).fieldType))
          );
        })
        .map((opt) => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
        .join(',')
    : [];

  const dataCollectionFieldName = collection ? `data-img-src-${collection.collectionId}` : '';
  const dataSessionFieldName = `data-session`;
  const dataSessionTenantFieldName = `data-session-tenant`;
  const dataSessionUserSettingsFieldName = 'data-session-user-settings';
  const dataSessionSubTenantFieldName = 'data-session-sub-tenant';
  let componentContent = '';
  const style = document.createElement('style');
  style.innerHTML = `
        .checkmark::after {
            left: 4px;
            top: 4px;
        }
        checkbox{
        all:unset;
        }
       
        select option:first-child {
            color: grey;
        }
        select.empty {
            color: grey;
        }
        select option[disabled]:first-child {
            display: none;
        }
        input[type=webconnect-text] {
            display:block;
        }
        input[type=webconnect-link] {
          display:block;
      }
        
  `;
  document.head.appendChild(style);
  if (collection || session || sessionTenant || sessionUserSettings || sessionSubTenant) {
    traitManager.addType(opt.traits.link.type, {
      createInput({ trait }) {
        const component = editor.getSelected();
        const childFileDataGroup = component.closestType('child-data-group-file');
        const dataTableComp = component.closestType('data-table');
        const dataGroupComp = component.closestType('data-group');
        const linkBoxComp = component.closestType('link-box');
        const addPopupTrait = !!(linkBoxComp && (childFileDataGroup || dataTableComp));

        componentContent = trait.attributes.content;
        const el = document.createElement('div');
        el.classList.add('custom-field');
        el.innerHTML = `    
              <div id="URL">
                ${
                  collection
                    ? `
                    <div class="form-group">
                          <label>
                              <input type="radio" name="getTextFrom"  value="collection"
                                    style="all: revert;"/>
                              Get Image From ${collection.collectionTitle}
                          </label>
                    </div>
                          `
                    : ''
                }
                ${
                  session && !childFileDataGroup && !dataTableComp && !dataGroupComp
                    ? `
                    <div class="form-group">
                          <label>
                              <input type="radio" name="getTextFrom"  value="session" style="all: revert;"/>
                              Get Image From Logged In User
                          </label>
                      </div>
                          `
                    : ''
                }
                ${
                  sessionTenant && !childFileDataGroup && !dataTableComp && !dataGroupComp
                    ? `
                    <div class="form-group">
                          <label>
                              <input type="radio" name="getTextFrom"  value="sessionTenant" style="all: revert;"/>
                              Get Image From Logged In Tenant
                          </label>
                      </div>
                          `
                    : ''
                }
                 ${
                   sessionUserSettings && !childFileDataGroup && !dataTableComp && !dataGroupComp
                     ? `
                    <div class="form-group">
                          <label>
                              <input type="radio" name="getTextFrom"  value="sessionUserSettings" style="all: revert;"/>
                              Get Image From Logged In User Settings
                          </label>
                      </div>
                          `
                     : ''
                 }
                  ${
                    sessionSubTenant && !childFileDataGroup && !dataTableComp && !dataGroupComp
                      ? `
                          <div class="form-group">
                                <label>
                                    <input type="radio" name="getTextFrom"  value="sessionSubTenant" style="all: revert;"/>
                                    Get Image From Logged In Sub Tenant
                                </label>
                            </div>
                                `
                      : ''
                  }
                <div class="form-group">
                    <div id="select-field-div" style="display: none">
                        <select class="selectField form-control form-control-sm options-light">
        
                        </select>
                    </div>
                </div>

                ${
                  addPopupTrait
                    ? `<div class="form-group">
                      <label>
                          <input type="checkbox" name="enablePopup" style="all: revert;"/>
                          View in Popup
                      </label>
                  </div>`
                    : ''
                }
            </div> 
            </div>
            `;
        const radioButtons = el.querySelectorAll('input[type=radio][name="getTextFrom"]');
        const enablePopupCheckbox = el.querySelector('input[type=checkbox][name="enablePopup"]');
        //const checkbox = el.querySelector('input[type=checkbox][name="getSrcFrom"]');
        const selectFieldDiv = el.querySelector('#select-field-div');
        const selectField = el.querySelector('.selectField');
        let selectedRadioButtonValue = null;
        radioButtons.forEach((radioButton) => {
          radioButton.addEventListener('click', async (ev) => {
            selectedRadioButtonValue = radioButton.value;
            selectField.innerHTML = '';
            let optionHtml = `<option value="">None</option>`;
            selectFieldDiv.style.display = 'block';
            if (radioButton.value === 'session') {
              optionHtml += `${session.options
                .map((opt) => `<option value="${opt.id}" type="${opt.type}">${opt.name}</option>`)
                .join('')}`;
            } else if (radioButton.value === 'collection') {
              optionHtml += traitOptions;
            } else if (radioButton.value === 'sessionTenant') {
              optionHtml += `${sessionTenant.options
                .map((opt) => `<option value="${opt.id}" type="${opt.type}">${opt.name}</option>`)
                .join('')}`;
            } else if (radioButton.value === 'sessionUserSettings') {
              optionHtml += `${sessionUserSettings.options
                .map((opt) => `<option value="${opt.id}" type="${opt.type}">${opt.name}</option>`)
                .join('')}`;
            } else if (radioButton.value === 'sessionSubTenant') {
              optionHtml += `${sessionSubTenant.options
                .map((opt) => `<option value="${opt.id}" type="${opt.type}">${opt.name}</option>`)
                .join('')}`;
            }
            selectField.innerHTML = optionHtml;
          });
        });
        enablePopupCheckbox && enablePopupCheckbox.addEventListener('click', (ev) => {});
        return el;
      },
      onEvent({ elInput, component }) {
        const select = elInput.querySelector('.selectField');
        let radioButton = document.querySelector('input[name="getTextFrom"]:checked');
        radioButton = radioButton ? radioButton.value : '';
        const enablePopupCheckbox = document.querySelector('input[name="enablePopup"]');
        let enablePopupCheckboxValue = enablePopupCheckbox ? enablePopupCheckbox.checked : false;

        let selectFieldValue = select ? select.value : '';
        const selectedOption = select.options[select.selectedIndex];
        const fieldType = selectedOption ? selectedOption.getAttribute('type') : '';
        if (selectFieldValue.includes("'")) {
          selectFieldValue = selectFieldValue.split("'").join('"');
        }
        console.log('selectFieldValue::', selectFieldValue, '--');
        const attr = component.getAttributes();
        if (enablePopupCheckbox) {
          if (enablePopupCheckboxValue) {
            attr['data-enable-popup'] = true;
            component.set('enablePopup', true);
          } else {
            delete attr['data-enable-popup'];
            component.set('enablePopup', false);
          }
        } else if (radioButton === 'collection' && selectFieldValue) {
          attr[dataCollectionFieldName] = selectFieldValue;
          delete attr['data-field-type'];
        } else if (radioButton === 'session' && selectFieldValue) {
          attr[dataSessionFieldName] = selectFieldValue;
          attr['data-field-type'] = fieldType;
        } else if (radioButton === 'sessionTenant' && selectFieldValue) {
          attr[dataSessionTenantFieldName] = selectFieldValue;
          attr['data-field-type'] = fieldType;
        } else if (radioButton === 'sessionUserSettings' && selectFieldValue) {
          attr[dataSessionUserSettingsFieldName] = selectFieldValue;
          attr['data-field-type'] = fieldType;
        } else if (radioButton === 'sessionSubTenant' && selectFieldValue) {
          attr[dataSessionSubTenantFieldName] = selectFieldValue;
          attr['data-field-type'] = fieldType;
        } else {
          delete attr[dataSessionFieldName];
          delete attr[dataCollectionFieldName];
          delete attr[dataSessionTenantFieldName];
          delete attr['data-field-type'];
          delete attr[dataSessionUserSettingsFieldName];
          delete attr[dataSessionSubTenantFieldName];
        }
        component.setAttributes(attr);
      },
      onUpdate({ elInput, component }) {
        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const selectField = elInput.querySelector('.selectField');
        const enablePopupCheckbox = elInput.querySelector('input[name="enablePopup"]');

        const attr = component.getAttributes();

        if (enablePopupCheckbox) {
          const enablePopup = component.get('enablePopup');
          if (enablePopup) {
            enablePopupCheckbox.checked = true;
          } else {
            enablePopupCheckbox.checked = false;
          }
        }

        let collectionFieldValue = attr[dataCollectionFieldName] || '';
        const sessionFieldValue = attr[dataSessionFieldName] || '';
        const sessionTenantFieldValue = attr[dataSessionTenantFieldName] || '';
        const sessionUserSettingsFieldValue = attr[dataSessionUserSettingsFieldName] || '';
        const sessionSubTenantFieldValue = attr[dataSessionSubTenantFieldName] || '';
        if (sessionFieldValue) {
          const sessionRadioButton = elInput.querySelector('input[value="session"]');
          sessionRadioButton ? (sessionRadioButton.checked = true) : '';
          selectField.innerHTML = '';
          let optionHtml = `<option value="" >- Select One -</option>`;
          optionHtml += `${session.options
            .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectField.value = sessionFieldValue;
          selectFieldDiv.style.display = 'block';
        } else if (collectionFieldValue) {
          const collectionRadioButton = elInput.querySelector('input[value="collection"]');
          collectionRadioButton ? (collectionRadioButton.checked = true) : '';
          selectField.innerHTML = '';
          let optionHtml = `<option value="" selected>- Select One -</option>`;
          optionHtml += traitOptions;
          selectField.innerHTML = optionHtml;
          if (collectionFieldValue.includes('"')) {
            collectionFieldValue = collectionFieldValue.split('"').join("'");
          }
          selectField.value = collectionFieldValue;
          selectFieldDiv.style.display = 'block';
        } else if (sessionTenantFieldValue) {
          const sessionTenantRadioButton = elInput.querySelector('input[value="sessionTenant"]');
          sessionTenantRadioButton ? (sessionTenantRadioButton.checked = true) : '';
          selectField.innerHTML = '';
          let optionHtml = `<option value="" >- Select One -</option>`;
          optionHtml += `${sessionTenant.options
            .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectField.value = sessionTenantFieldValue;
          selectFieldDiv.style.display = 'block';
        } else if (sessionUserSettingsFieldValue) {
          const sessionUserSettingsRadioButton = elInput.querySelector(
            'input[value="sessionUserSettings"]',
          );
          sessionUserSettingsRadioButton ? (sessionUserSettingsRadioButton.checked = true) : '';
          selectField.innerHTML = '';
          let optionHtml = `<option value="" >- Select One -</option>`;
          optionHtml += `${sessionUserSettings.options
            .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectField.value = sessionUserSettingsFieldValue;
          selectFieldDiv.style.display = 'block';
        } else if (sessionSubTenantFieldValue) {
          const sessionSubTenantRadioButton = elInput.querySelector(
            'input[value="sessionSubTenant"]',
          );
          sessionSubTenantRadioButton ? (sessionSubTenantRadioButton.checked = true) : '';
          selectField.innerHTML = '';
          let optionHtml = `<option value="" >- Select One -</option>`;
          optionHtml += `${sessionSubTenant.options
            .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectField.value = sessionSubTenantFieldValue;
          selectFieldDiv.style.display = 'block';
        }
      },
    });
  } else {
    traitManager.addType(opt.traits.link.type, {
      createInput({ trait }) {
        const el = document.createElement('div');
        el.innerHTML = ``;
        return el;
      },
    });
  }
}
